import { render } from "./DeveloperOverviewComponent.vue?vue&type=template&id=68aaa1ee&scoped=true"
import script from "./DeveloperOverviewComponent.vue?vue&type=script&lang=js"
export * from "./DeveloperOverviewComponent.vue?vue&type=script&lang=js"

import "./DeveloperOverviewComponent.vue?vue&type=style&index=0&id=68aaa1ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aaa1ee"]])

export default __exports__